/**
 * @flow
 * @relayHash b0bdc4e057e089829f0d21bd4ce96082
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GLSyncStatus = "FAILED" | "NOT_APPLICABLE" | "PENDING" | "SYNCED";
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type JournalSourceType = "INVENTORY_ADJUSTMENT" | "INVOICE" | "JOB" | "MANUAL" | "PAYMENT" | "SHIPMENT";
export type AddJournalEntryInput = {|
  entryDate?: ?any,
  memo?: ?string,
  lines: $ReadOnlyArray<JournalLineInput>,
|};
export type JournalLineInput = {|
  glAccountId: string,
  debit?: ?number,
  credit?: ?number,
  memo?: ?string,
  entityType?: ?string,
  entityId?: ?string,
|};
export type AddJournalEntryMutationVariables = {|
  input: AddJournalEntryInput
|};
export type AddJournalEntryMutationResponse = {|
  +addJournalEntry: {|
    +journalEntryEdge: {|
      +node: {|
        +id: string,
        +entryNumber: string,
        +entryDate: any,
        +memo: ?string,
        +sourceType: JournalSourceType,
        +status: JournalEntryStatus,
        +syncStatus: GLSyncStatus,
        +postedAt: ?any,
        +totalDebit: number,
        +totalCredit: number,
        +createdByUser: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +lines: $ReadOnlyArray<{|
          +id: string,
          +account: {|
            +id: string,
            +accountNumber: string,
            +name: string,
          |},
          +debit: number,
          +credit: number,
          +memo: ?string,
        |}>,
        +createdAt: any,
        +updatedAt: any,
      |}
    |}
  |}
|};
export type AddJournalEntryMutation = {|
  variables: AddJournalEntryMutationVariables,
  response: AddJournalEntryMutationResponse,
|};
*/


/*
mutation AddJournalEntryMutation(
  $input: AddJournalEntryInput!
) {
  addJournalEntry(input: $input) {
    journalEntryEdge {
      node {
        id
        entryNumber
        entryDate
        memo
        sourceType
        status
        syncStatus
        postedAt
        totalDebit
        totalCredit
        createdByUser {
          id
          firstName
          lastName
        }
        lines {
          id
          account {
            id
            accountNumber
            name
          }
          debit
          credit
          memo
        }
        createdAt
        updatedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddJournalEntryInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "memo",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addJournalEntry",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddJournalEntryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "journalEntryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "JournalEntryEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "JournalEntry",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "entryNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "entryDate",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "sourceType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "syncStatus",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "postedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalDebit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCredit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "createdByUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lines",
                "storageKey": null,
                "args": null,
                "concreteType": "JournalLine",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "account",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GLAccount",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accountNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "debit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "credit",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddJournalEntryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddJournalEntryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddJournalEntryMutation",
    "id": null,
    "text": "mutation AddJournalEntryMutation(\n  $input: AddJournalEntryInput!\n) {\n  addJournalEntry(input: $input) {\n    journalEntryEdge {\n      node {\n        id\n        entryNumber\n        entryDate\n        memo\n        sourceType\n        status\n        syncStatus\n        postedAt\n        totalDebit\n        totalCredit\n        createdByUser {\n          id\n          firstName\n          lastName\n        }\n        lines {\n          id\n          account {\n            id\n            accountNumber\n            name\n          }\n          debit\n          credit\n          memo\n        }\n        createdAt\n        updatedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dbe8b3275b7bec01d38f5edc4fb63546';
module.exports = node;
